import Link from 'next/link';

import { Divider } from 'antd';

import { resources } from '@/common/constants/footer';

import Logo from '~/public/assets/svg/header-logo.svg';
import MapPin from '~/public/assets/svg/map-pin.svg';
import Phone from '~/public/assets/svg/phone.svg';

import Licenses from './components/licenses.component';
import SocialMediaLinks from './components/social-media-links.component';

const Footer = () => {
  return (
    <footer className="bg-black text-white px-4 pt-20 pb-9 md:px-30">
      <div className="flex flex-col gap-4 text-sm leading-5 font-normal md:flex-row md:gap-19.75 md:flex-wrap md:justify-between items-start md:text-base md:leading-6.5">
        <div className="md:max-w-64.5 flex flex-col gap-4 md:gap-6">
          <div className="flex justify-between items-start">
            <Logo className="w-21 h-6.25 md:w-30.5 md:h-9" />
            <SocialMediaLinks className="md:hidden" />
          </div>
          <p>
            اپليكيشن فروشگاه‌ساز ويترو با ويژگى‌هايى ساخته شد تافروشگاه‌هاى
            آنلاين راحت‌تر بفروشن و مشتريانشون بهتر بخرن. ويترو سعى مى‌كنه تجربه
            فروش آنلاين رو بهبود ببخشه.
          </p>
        </div>
        <div className="md:max-w-74.5  flex flex-col gap-4">
          <div>
            <h3 className="text-base font-semibold mb-3">تماس باما</h3>
            <div className="flex items-start gap-2">
              <div className="w-5 h-5">
                <MapPin />
              </div>
              <span>
                تهران، خيابان مطهرى، خيابان على اكبرى، كوچه حاج محمديان، پلاك
                ۲۴، طبقه ۳، واحد‍ ۵
              </span>
            </div>
            <div className="flex gap-2 mt-2.5 md:mt-4">
              <Phone />
              <div className="flex flex-col">
                {/* <Link href="tel:+982191031801">
                  <span dir="ltr">021 - 91031801</span>
                </Link> */}
                <Link href="tel:+982192003494">
                  <span dir="ltr">021 - 92003494</span>
                </Link>
              </div>
            </div>
          </div>
          <div>
            <h3 className="text-base font-semibold mb-3">روزهای کاری</h3>
            <span>
              شنبه تا چهارشنبه از ساعت ۸ صبح تا ۱۲ شب - روزهای تعطیل از ۸ صبح تا
              ۴ بعد از ظهر
            </span>
          </div>
        </div>
        <div className="md:max-w-26">
          <h3 className="text-base font-semibold mb-3">منابع</h3>
          <div className="flex flex-col gap-2.5">
            {resources.map((source, index) => (
              <Link key={index} href={source.link}>
                {source.text}
              </Link>
            ))}
          </div>
        </div>
        <Licenses />
      </div>
      <Divider className="my-3.5! bg-silver-800 md:mt-11.75! md:mb-6.75!" />
      <div className="flex justify-between items-center">
        <span className="text-xs font-normal text-center md:text-right md:text-base md:font-medium">
          ® تمامى حقوق متعلق به شركت نقش آواتك (سهامى خاص) مى‌باشد
        </span>
        <SocialMediaLinks className="hidden md:flex" />
      </div>
    </footer>
  );
};

export default Footer;
